export class CurrencyFormatter {
    static formatToDollarValue = (value: number): string => {
        if (value === 0) return '$0.00';
        value = Math.round(value * 100) / 100;
        const formattedValue = Math.abs(value).toLocaleString(undefined, {
            minimumFractionDigits: value % 1 === 0 ? 0 : 2,
            maximumFractionDigits: value % 1 === 0 ? 0 : 2,
        });
        return value < 1 ? `($${formattedValue})` : `$${formattedValue}`;
    };
}
